import React from "react";

export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="bg-white border-b border-slate-200 px-4 sm:px-8 py-4 sm:py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div>
        <h1 className="font-display text-xl sm:text-2xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <div className="text-xs sm:text-sm text-slate-500 mt-0.5">{subtitle}</div>}
      </div>
      <div className="flex flex-wrap items-center gap-2 sm:mr-[190px]">{children}</div>
    </div>
  );
}
